import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

export interface IReportGenerated extends IIdTitle {
    downloadId: string;
    fileName: string;
    content: string;
    mediaType: string;
    listWidth: number;
    taskType: ITaskEditTypeItem;
    dataRows: ITaskDataRow[];
}

export class ReportGenerated extends IdTitle implements IReportGenerated {
    downloadId: string;
    fileName: string;
    content: string;
    mediaType: string;
    listWidth: number;
    taskType: TaskEditTypeItem;
    dataRows: TaskDataRow[];

    constructor();
    constructor(obj: IReportGenerated);
    constructor(obj?: any) {
        super(obj);
        this.downloadId = obj && obj.downloadId || "";
        this.fileName = obj && obj.fileName || "";
        this.content = obj && obj.content || "";
        this.mediaType = obj && obj.mediaType || "";
        this.listWidth = obj && obj.listWidth || 0;
        this.taskType = new TaskEditTypeItem(obj ? obj.taskType : null);
        this.dataRows = Base.getTypedArray(obj ? obj.dataRows : null, TaskDataRow);
        for (const dataRow of this.dataRows) {
            dataRow.initializeCols(this.taskType);
        }
    }
}